import { Link, useLocation } from 'react-router-dom';
import BrandLogo from '../../../../shared/components/BrandLogo';
import AuthService from '../../../../shared/services/AuthService';
import { isMarketplaceBuyerRole } from '../../../../routes/roles';
import { useGuestWishlistCount } from '../hooks/useWishlist';

export default function MarketplaceHeader() {
  const { pathname } = useLocation();
  const isLoggedIn = Boolean(AuthService.getToken?.());
  const isBuyer = isLoggedIn && isMarketplaceBuyerRole(AuthService.getLoggedInRoleId());
  const guestWishlistCount = useGuestWishlistCount();

  return (
    <header className="marketplace-header">
      <div className="marketplace-container marketplace-header-inner">
        <Link to="/marketplace" className="marketplace-logo">
          <BrandLogo size={36} />
          <span>NextFollowUp</span>
        </Link>

        <nav className="marketplace-nav" aria-label="Marketplace">
          <Link to="/marketplace" aria-current={pathname === '/marketplace' ? 'page' : undefined}>
            Properties
          </Link>
          <Link
            to="/marketplace/search"
            aria-current={pathname.startsWith('/marketplace/search') ? 'page' : undefined}
          >
            Search
          </Link>
          <Link to="/about">About</Link>
          <Link to="/contact-sales">Help</Link>
        </nav>

        <div className="marketplace-header-actions">
          <Link
            to="/marketplace/search"
            className="marketplace-header-icon-btn"
            aria-label="Search properties"
          >
            <i className="fas fa-search" aria-hidden />
          </Link>
          <Link
            to="/marketplace/account/saved"
            className="marketplace-header-icon-btn"
            aria-label="Saved properties"
            title="Saved properties"
          >
            <i className="fas fa-heart" aria-hidden />
            {!isBuyer && guestWishlistCount > 0 ? (
              <span style={{ fontSize: 11, marginLeft: 2 }}>{guestWishlistCount}</span>
            ) : null}
          </Link>
          {isBuyer ? (
            <Link to="/marketplace/account/profile" className="market-btn market-btn-secondary">
              My account
            </Link>
          ) : (
            <>
              <Link to="/marketplace/account/login" className="market-btn market-btn-secondary">
                Sign in
              </Link>
              <Link to="/marketplace/account/register" className="market-btn market-btn-primary">
                Sign up
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
